import VueI18n from 'vue-i18n';

// Ticket statuses as the helpdesk stores them. The codes are fixed; what each one means to the
// team (and its name) lives in the `helpdesk.ticketStatus` translations:
//   open → in progress · pending → waiting on someone outside · resolved · closed → closed or invalid
export type TicketStatus = 'open' | 'pending' | 'resolved' | 'closed';

export const TICKET_STATUSES: TicketStatus[] = ['open', 'pending', 'resolved', 'closed'];

// Chart colours (dashboard donut and weekly stacks). Checked with the dataviz palette validator
// on the light surface in this order (it is the stacking order, bottom to top): every adjacent
// pair is told apart with normal vision and colour blindness, and all clear 3:1 on white.
// Closed is a deliberate low-chroma slate: it is the bucket that matters least.
export const TICKET_STATUS_COLORS: {[status in TicketStatus]: string} = {
  open:     '#1d7afc',
  pending:  '#b38600',
  resolved: '#22a06b',
  closed:   '#626f86',
};

export function ticketStatusLabel(i18n: VueI18n, status: string): string {
  const key = 'helpdesk.ticketStatus.' + status;
  return i18n.te(key) ? i18n.t(key) as string : status;
}

/** Compact name for lozenges, chips and charts; show ticketStatusLabel as its tooltip. */
export function ticketStatusShortLabel(i18n: VueI18n, status: string): string {
  const key = 'helpdesk.ticketStatusShort.' + status;
  return i18n.te(key) ? i18n.t(key) as string : ticketStatusLabel(i18n, status);
}

/** Items for a v-select / v-autocomplete. */
export function ticketStatusOptions(i18n: VueI18n): Array<{text: string; value: TicketStatus}> {
  return TICKET_STATUSES.map((value) => ({text: ticketStatusLabel(i18n, value), value}));
}
